import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError } from "../../utils/api.types";

import {
    ICurrencyResponse,
    ICurrencies,
    ICurrency
} from "../../utils/currency.types";

/**
 * Fetch currencies async thunk.
*/
export const fetchCurrencies = createAsyncThunk(
    'currency/fetchCurrencies',
    async (): Promise<ICurrency[]> => {
        const response = await axios.get(`/api/v1/curriences`);
        return response.data.currencies;
    }
);

